import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a02c5500"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/static/images/logo.png",
    alt: "logo"
  })
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "微信授权登入失败，请检查网络和设备运行正常后后点击下方按钮授权登录。", -1))

import { ref, computed, onMounted, reactive } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import {
  AUTH_KEY,
  USER_FIRST_VISISIT_LINK,
  USER_LOGIN_FAIL_COUNT,
} from '@/enums/cacheEnum'
import { useUserStore } from '@/store/modules/user'
import Storage from '@/utils/Storage'
import { getWxOAuthPath } from '@/utils/common'
import { equipmentType } from '@/utils/common'


export default /*#__PURE__*/_defineComponent({
  __name: 'AuthorView',
  setup(__props) {

const router = useRouter()
const route = useRoute()
const userStore = useUserStore()
const isIOS = equipmentType() === 'ios'

let iosReload_timer = 0

const state = reactive({
  token: '',
  login_fail_count: Number(Storage.get(USER_LOGIN_FAIL_COUNT)) || 0,
})

const showLoginFailHelp = computed(() => {
  return Boolean(state.login_fail_count > 3)
})

// 跳转到授权链接
const jumpToAuthor = () => {
  location.href = getWxoAuthPath()
}
// 获取授权地址
const getWxoAuthPath = () => {
  let shareToken = route.query?.shareToken
  let query = ''
  if (shareToken) {
    query = `shareToken=${shareToken}`
  }
  return getWxOAuthPath(query)
}

// 登入失败，更新失败信息
const loginFailCallback = () => {
  state.login_fail_count++
  Storage.set(USER_LOGIN_FAIL_COUNT, String(state.login_fail_count))
  console.error('LOGIN FAIL', state.login_fail_count)
  if (state.login_fail_count <= 3) jumpToAuthor()
}

onMounted(async () => {
  console.log('AuthView=mounted=token=>', state.token)
  console.log('href', location.href)

  const key = route.query?.key as string
  const isDebug = route.query?.debug !== undefined
  const authKey = Storage.get(AUTH_KEY)
  // 校验授权KEY
  if (authKey !== key && !isDebug) {
    // 非法登入
    loginFailCallback()
    return false
  }

  state.token = route.query?.token as string

  if (state.token) {
    // 校验并保存用户信息
    userStore.setToken(state.token)
    const resp: any = await userStore.getUserInfo()
    console.log('resp.ret===>', resp)
    if (resp?.ret !== 100) {
      console.log('resp.ret !== 100')
      loginFailCallback()
    } else {
      // 重置登入成功失败信息
      Storage.remove(USER_LOGIN_FAIL_COUNT)
      userStore.setToken(state.token)
      const visit_link = Storage.get(USER_FIRST_VISISIT_LINK)
      console.log('visit_link==>', visit_link)
      if (visit_link) {
        // 登入成功清楚记忆链接
        Storage.remove(USER_FIRST_VISISIT_LINK)
        // 跳转到访问链接
        location.href = visit_link
        // router.push(visit_link)
      } else {
        location.href = '/'
        // router.push('/')
      }
      // fix ios back location.href无效
      // if (isIOS) {
      //   clearTimeout(iosReload_timer)
      //   iosReload_timer = setTimeout(() => {
      //     // 无效
      //     // router.go(0)
      //     location.href = visit_link || '/'
      //   }, 60)
      // }
    }
  } else {
    console.log('no token=======>')
    loginFailCallback()
  }
})

return (_ctx: any,_cache: any) => {
  return (_unref(showLoginFailHelp))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _createElementVNode("div", {
          onClick: jumpToAuthor,
          class: "btn-oauth ufb ufb-ac ufb-pc"
        }, " 微信账号登录 ")
      ]))
    : _createCommentVNode("", true)
}
}

})